// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Enums
import { FundChartOptionValue } from 'ChartApp/ts/enums/fund-chart-common.enum';
// Action imports
import { setChartOption } from './chart-options.actions';
import { setFundChart } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart.actions';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
export const units = createReducer(false, on(setChartData, (state, { chartData }) => chartData.params.units), on(setChartOption, (state, action) => {
    if (action.chartOption.value === FundChartOptionValue.SHOW_UNITS_IN_LEGEND) {
        return action.chartOption.selected;
    }
    return state;
}), on(setFundChart, (state, action) => {
    return action.fundChart[FundChartOptionValue.SHOW_UNITS_IN_LEGEND];
}));
